import { useEffect, useState, useRef } from "react";
import "../Css/Footer.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import playStoreImage from "D:/Abhi2/my-app/src/assets/playstore.crdownload.png";
import iosImage from "D:/Abhi2/my-app/src/assets/ios.crdownload.png";
const Footer = () => {
  const [visitorCount, setVisitorCount] = useState(0);
  const [totalVisits, setTotalVisits] = useState(0);
  const hasCountedRef = useRef(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!hasCountedRef.current) {
      const fetchVisitorData = async () => {
        try {
          const response = await fetch(
            "https://api.gkaglobal.org/restgka/logvisit/visitor_count.php"
          );

          if (!response.ok) {
            throw new Error("Failed to fetch visitor data");
          }

          const data = await response.json();
          setVisitorCount(data.unique_visitors);
          setTotalVisits(data.total_visits);
        } catch (err) {
          setError(err.message);
          console.error("Error fetching visitor data:", err);
        } finally {
          setLoading(false);
        }
      };

      fetchVisitorData();
      hasCountedRef.current = true;
    }
  }, [loading, error]); // Empty dependency array means this runs once on mount

  return (
    <>
      <div className="orange-strip">&nbsp;</div>
      <footer className="bg-gray-900 text-white py-1">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 border-b border-orange-500 pb-6">
            {/* Committee Members */}
            <div>
              <h2 className="text-lg font-semibold whitespace-nowrap">
                Committee Members
              </h2>
              <ul className="mt-2 space-y-1">
                {[
                  "Ravindra R. Parmar",
                  "Paresh Pankhavala",
                  "Vinod Chauhan",
                  "Avani Chauhan",
                ].map((name) => (
                  <li
                    key={name}
                    className="hover:text-orange-400 cursor-pointer"
                  >
                    {name}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="invisible">&nbsp;</h2>
              <ul className="mt-2 space-y-1">
                {[
                  "Arun Arya",
                  "Kanti R. Chavada",
                  "Jekishanbhai R. Chauhan",
                  "Mahendrabhai Solanki",
                ].map((name) => (
                  <li
                    key={name}
                    className="hover:text-orange-400 cursor-pointer"
                  >
                    {name}
                  </li>
                ))}
              </ul>
            </div>
            <div className="border-r border-orange-500 pr-4">
              <h2 className="invisible">&nbsp;</h2>
              <ul className="mt-2 space-y-1">
                {[
                  "Jayantibhai R. Chauhan",
                  "Thakorbhai Bulsara",
                  "Harish Doolabh",
                  "Daxaben B. Chauhan",
                ].map((name) => (
                  <li
                    key={name}
                    className="hover:text-orange-400 cursor-pointer"
                  >
                    {name}
                  </li>
                ))}
              </ul>
            </div>
            {/* Board of Advisors */}
            <div>
              <h2 className="text-lg font-semibold whitespace-nowrap">
                Board of Advisors
              </h2>
              <ul className="mt-2 space-y-1">
                {[
                  "Amritbhai Champaneri",
                  "Jasvantbhai Nana",
                  "Natvarbhai Nana",
                  "Maheshbhai Solanki",
                ].map((name) => (
                  <li
                    key={name}
                    className="hover:text-orange-400 cursor-pointer"
                  >
                    {name}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="invisible">&nbsp;</h2>
              <ul className="mt-2 space-y-1">
                {[
                  "Jaydevbhai Varma",
                  "Jagubhai Champaneri",
                  "Shashi Champaneri",
                  "Jayantibhai Panchal",
                ].map((name) => (
                  <li
                    key={name}
                    className="hover:text-orange-400 cursor-pointer"
                  >
                    {name}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="invisible">&nbsp;</h2>
              <ul className="mt-2 space-y-1">
                {["Kamlesh Chauhan", "Rajesh Kumar Chauhan"].map((name) => (
                  <li
                    key={name}
                    className="hover:text-orange-400 cursor-pointer"
                  >
                    {name}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Store Links */}
          <div className="footer-container">
            {/* Left Content - App Links */}
            <div className="app-links">
              <a
                href="https://apps.apple.com/us/app/gka-app/id6467197428"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={iosImage} alt="App Store" />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.gkaglobal.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={playStoreImage}
                  alt="Google Play Store"
                  style={{ width: "160px" }}
                />
              </a>
            </div>

            {/* Center Content - Visitor Counter */}
            <div className="visitor-counter">
              <h2 className="visit">
                <strong>({visitorCount})</strong> Total Visits:{" "}
                <strong>({totalVisits})</strong>
              </h2>
            </div>

            {/* Right Content - Links */}
            <div className="position-relative bottom-0 end-0 mb-3 me-3 text-end">
              <Link
                to="https://api.gkaglobal.org/gkawebsite/Privacy%20Policy.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white px-3 py-2 rounded mb-2 me-2 hover-link"
              >
                Privacy Policy
              </Link>
              <Link
                to="https://gkaglobal.org/admin/admin/login"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white px-3 py-2 rounded hover-link"
              >
                Admin Login1
              </Link>
            </div>
          </div>

          {/* Scroll to Top */}
          <div
            className="fixed bottom-6 right-6 bg-orange-500 text-white p-3 rounded-full shadow-lg cursor-pointer hover:bg-orange-600 bg-radial-gradient "
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <FontAwesomeIcon
              icon={faAngleUp}
              className="text-lg "
              style={{ height: "40px", width: "40px" }}
            />
          </div>
        </div>

        <div className="footerbottom_area">
          <div className="container text-center">
            <p className="copy">
              Copyright © 2021-2022 Gujarati Kshatriya Association USA & Canada.
              All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
